<template>
  <ApexChart v-if="chartOption && chartOption.series && chartOption.series.length > 0"
    element="starboardFlowRateChart" :chartOption="chartOption" :series="chartOption.series" />
</template>

<script>
// import moment from 'moment';

export default {
  name: 'StarboardFlowRateChart',
  props: {
    series: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chartOption() {
      if (!this.series || this.series.length === 0) return null;

      const seriesData = this.series.length > 60 ? this.series.slice(-60) : this.series;

      const mappedData = seriesData.map((data) => {
        const raw = data && data.fmData && Number.isFinite(Number(data.fmData.STARBOARD_InFlow))
          ? Number(data.fmData.STARBOARD_InFlow) : null;
        return Number.isFinite(raw) ? Number(raw.toFixed(2)) : null;
      });

      const interpolatedData = this.interpolateNulls(mappedData);

      const chartSeries = [
        { name: 'Starboard AVG Flow Rate (Interpolated)', data: interpolatedData },
        { name: 'Starboard AVG Flow Rate', data: mappedData },
      ];

      return {
        series: chartSeries,
        chart: {
          height: 60,
          width: '100%',
          type: 'area',
          sparkline: {
            enabled: true,
          },
          group: 'sparklines',
        },
        markers: {
          size: 0,
          hover: {
            size: 4,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: 'smooth',
          dashArray: [4, 0], // Garis pertama putus-putus, garis kedua solid
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0,
          },
        },
        colors: ['rgba(0, 202, 0, 0.4)', '#2ecc71'],
        xaxis: {
          type: 'datetime',
          categories: seriesData.map((data) => data.timestamp * 1000),
        },
        tooltip: {
          enabled: true,
          followCursor: true,
          intersect: false,
          enabledOnSeries: [1],
          x: {
            format: 'dd/MM/yy HH:mm',
          },
        },
      };
    },
  },
  methods: {
    interpolateNulls(dataArray) {
      const result = [...dataArray];
      for (let i = 0; i < result.length; i++) {
        if (result[i] === null) {
          const startIndex = i - 1;
          const startValue = startIndex >= 0 ? result[startIndex] : null;

          if (startValue !== null) {
            let endIndex = -1;
            for (let j = i + 1; j < result.length; j++) {
              if (result[j] !== null) {
                endIndex = j;
                break;
              }
            }

            if (endIndex !== -1) {
              const endValue = result[endIndex];
              const gapCount = endIndex - startIndex;
              const totalDifference = endValue - startValue;
              const step = totalDifference / gapCount;

              for (let k = startIndex + 1; k < endIndex; k++) {
                const interpolatedValue = startValue + step * (k - startIndex);
                result[k] = Number(interpolatedValue.toFixed(2));
              }
              i = endIndex - 1;
            }
          }
        }
      }
      return result;
    },
  },
};
</script>
